import { faEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Bold } from '#src/atoms/typography/Bold/index.tsx';
import { BodyS, LabelM } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';

const messages = defineMessages({
  title: {
    defaultMessage: 'Authorize a New Device',
  },
  description: {
    defaultMessage:
      "It looks like you're signing in to Sorare from a computer or device we haven't seen before.",
  },
  link: {
    defaultMessage:
      'Please <b>click the confirmation link in the email or text</b> we just sent you. This process is only required once per device and protects the security of your account.',
  },
});

const Root = styled(Vertical).attrs({ gap: 3 })`
  text-align: center;
  padding: var(--triple-unit);
`;
const Icon = styled(FontAwesomeIcon)`
  font-size: 80px;
  color: var(--c-blue-400);
  display: inline;
  margin: var(--double-unit) 0;
`;

type Props = {
  onClose: () => void;
};
export const NewDeviceDialog = ({ onClose }: Props) => {
  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      title={
        <Vertical center>
          <LabelM as="h2" bold>
            <FormattedMessage {...messages.title} />
          </LabelM>
        </Vertical>
      }
      onClose={onClose}
    >
      <Root>
        <Icon icon={faEnvelopeOpenText} />
        <BodyS as="p">
          <FormattedMessage {...messages.description} />
        </BodyS>
        <BodyS as="p">
          <FormattedMessage {...messages.link} values={{ b: Bold }} />
        </BodyS>
      </Root>
    </Dialog>
  );
};
